import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { Dropdown, DropdownItem, DropdownMenu } from 'element-ui'
import { MAX_RATINGS_PER_EVENT } from '@/util/ratings'
import type { GameRating, RatingScale } from '@/util/ratings'

// Ratings section body of the event editor (EditGame renders the section frame and title). Lists only the scales this event is rated on; "Add rating"
// attaches another active scale and the X removes one. Every rating uses its scale's look. v-model is the attached ratings only; the
// event save sends every active scale and the lambda deletes the ones that are not attached.

export default /*#__PURE__*/_defineComponent({
  __name: 'EventRatingsEditor',
  props: {
  value: { type: Array as () => GameRating[], default: () => [] },
  scales: { type: Array as () => RatingScale[], default: () => [] },
  // Save errors from the event editor, keyed by scale id.
  errors: { type: Object as () => Record<number, string>, default: () => ({}) },
},
  emits: ['input'],
  setup(__props, { emit }) {

const props = __props





// Element components used in the template that are not globally registered.
const ElDropdown = Dropdown
const ElDropdownMenu = DropdownMenu
const ElDropdownItem = DropdownItem


// Attached ratings in scale order, each paired with its scale. Ratings on archived scales are not listed.
const attached = computed(() => props.scales
  .map(scale => ({ scale, rating: props.value.find(r => r.rating_scale_id === scale.id) }))
  .filter((item): item is { scale: RatingScale, rating: GameRating } => !!item.rating))

const available = computed(() => props.scales.filter(scale => !props.value.some(r => r.rating_scale_id === scale.id)))

const atLimit = computed(() => attached.value.length >= MAX_RATINGS_PER_EVENT)

// A rating's name is always its scale's name. Per-event icons and colors only come from migrated
// events (venues that styled each event differently before scales existed). The editor never sets
// one; it can only clear it back to the scale's look.
function hasOwnLook(rating: GameRating) {
  return !!(rating.icon || rating.color)
}

// An icons rating starts at 0, so an attached rating always has a value and is always saved.
// A named-levels rating has no zero: it starts empty and the event editor asks for a level on save.
function add(scaleId: number) {
  const scale = props.scales.find(s => s.id === scaleId)
  const value = scale && scale.display_type === 'labels' ? null : 0
  emit('input', [...props.value, { rating_scale_id: scaleId, value, label: null, icon: null, color: null, show_to_customers: true }])
}

function remove(scaleId: number) {
  emit('input', props.value.filter(r => r.rating_scale_id !== scaleId))
}

function update(scaleId: number, patch: Partial<GameRating>) {
  emit('input', props.value.map(r => (r.rating_scale_id === scaleId ? { ...r, ...patch } : r)))
}

return { __sfc: true,props, emit, ElDropdown, ElDropdownMenu, ElDropdownItem, attached, available, atLimit, hasOwnLook, add, remove, update, MAX_RATINGS_PER_EVENT }
}

})